(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-barra-de-anuncios"] && !Shopify.designMode) return;
  try {
    
(function () {
  function BarraAnuncios(raiz) {
    this.raiz = raiz;
    this.items = Array.prototype.slice.call(raiz.querySelectorAll('[data-anuncios-item]'));
    this.botonAnterior = raiz.querySelector('[data-anuncios-anterior]');
    this.botonSiguiente = raiz.querySelector('[data-anuncios-siguiente]');
    this.botonCerrar = raiz.querySelector('[data-anuncios-cerrar]');
    this.indice = 0;
    this.temporizador = null;
    this.temporizadorFade = null;
    this.enTransicion = false;
    this.velocidad = Math.max(1500, parseFloat(raiz.getAttribute('data-velocidad') || '5') * 1000);
    this.fade = Math.max(80, parseFloat(raiz.getAttribute('data-fade') || '450'));
    this.modo = raiz.getAttribute('data-modo');
    this.rotarMovil = raiz.getAttribute('data-rotar-movil') === 'true';
    this.clave = raiz.getAttribute('data-clave');
    this.consultaMovil = window.matchMedia('(max-width: 748px)');
    this.reduccion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.iniciar();
  }
  BarraAnuncios.prototype.estaCerrada = function () {
    try {
      return window.sessionStorage.getItem(this.clave) === 'cerrado';
    } catch (e) {
      return false;
    }
  };
  BarraAnuncios.prototype.guardarCierre = function () {
    try {
      window.sessionStorage.setItem(this.clave, 'cerrado');
    } catch (e) {
      return;
    }
  };
  BarraAnuncios.prototype.iniciar = function () {
    var self = this;
    if (this.estaCerrada() && !window.Shopify.designMode) {
      this.raiz.classList.add('esta-cerrado');
      return;
    }
    if (this.botonAnterior) {
      this.botonAnterior.addEventListener('click', function () {
        self.moverManual(-1);
      });
    }
    if (this.botonSiguiente) {
      this.botonSiguiente.addEventListener('click', function () {
        self.moverManual(1);
      });
    }
    if (this.botonCerrar) {
      this.botonCerrar.addEventListener('click', function () {
        self.cerrar();
      });
    }
    this.raiz.addEventListener('mouseenter', function () {
      self.detener();
    });
    this.raiz.addEventListener('mouseleave', function () {
      self.evaluar();
    });
    this.raiz.addEventListener('focusin', function () {
      self.detener();
    });
    this.raiz.addEventListener('focusout', function () {
      self.evaluar();
    });
    this.alCambiarVista = function () {
      self.evaluar();
    };
    if (this.consultaMovil.addEventListener) {
      this.consultaMovil.addEventListener('change', this.alCambiarVista);
    } else if (this.consultaMovil.addListener) {
      this.consultaMovil.addListener(this.alCambiarVista);
    }
    this.alCambiarVisibilidad = function () {
      if (document.hidden) {
        self.detener();
      } else {
        self.evaluar();
      }
    };
    document.addEventListener('visibilitychange', this.alCambiarVisibilidad);
    this.fijar(0);
    this.evaluar();
  };
  BarraAnuncios.prototype.rotacionActiva = function () {
    if (this.items.length < 2) return false;
    if (this.modo === 'rotativo') return true;
    return this.rotarMovil && this.consultaMovil.matches;
  };
  BarraAnuncios.prototype.fijar = function (indice) {
    this.indice = (indice + this.items.length) % this.items.length;
    for (var i = 0; i < this.items.length; i++) {
      var esActivo = i === this.indice;
      this.items[i].classList.toggle('esta-activo', esActivo);
      this.items[i].setAttribute('aria-hidden', esActivo ? 'false' : 'true');
    }
  };
  BarraAnuncios.prototype.transicionar = function (destino) {
    var self = this;
    if (this.enTransicion) return;
    var proximo = (destino + this.items.length) % this.items.length;
    if (proximo === this.indice) return;

    if (this.reduccion.matches) {
      this.fijar(proximo);
      return;
    }

    this.enTransicion = true;
    var saliente = this.items[this.indice];
    saliente.classList.remove('esta-activo');
    saliente.setAttribute('aria-hidden', 'true');

    window.clearTimeout(this.temporizadorFade);
    this.temporizadorFade = window.setTimeout(function () {
      self.indice = proximo;
      var entrante = self.items[proximo];
      entrante.classList.add('esta-activo');
      entrante.setAttribute('aria-hidden', 'false');
      self.enTransicion = false;
    }, this.fade);
  };
  BarraAnuncios.prototype.moverManual = function (paso) {
    this.detener();
    this.transicionar(this.indice + paso);
    this.evaluarDiferido();
  };
  BarraAnuncios.prototype.evaluarDiferido = function () {
    var self = this;
    window.setTimeout(function () {
      self.evaluar();
    }, this.fade + 50);
  };
  BarraAnuncios.prototype.arrancar = function () {
    var self = this;
    this.detener();
    this.temporizador = window.setInterval(function () {
      self.transicionar(self.indice + 1);
    }, this.velocidad + this.fade);
  };
  BarraAnuncios.prototype.detener = function () {
    if (this.temporizador) {
      window.clearInterval(this.temporizador);
      this.temporizador = null;
    }
  };
  BarraAnuncios.prototype.evaluar = function () {
    this.detener();
    if (!this.rotacionActiva()) {
      for (var i = 0; i < this.items.length; i++) {
        this.items[i].removeAttribute('aria-hidden');
      }
      return;
    }
    this.fijar(this.indice);
    if (!this.reduccion.matches && !window.Shopify.designMode) {
      this.arrancar();
    }
  };
  BarraAnuncios.prototype.cerrar = function () {
    this.detener();
    this.guardarCierre();
    this.raiz.classList.add('esta-cerrado');
  };
  BarraAnuncios.prototype.destruir = function () {
    this.detener();
    window.clearTimeout(this.temporizadorFade);
    document.removeEventListener('visibilitychange', this.alCambiarVisibilidad);
    if (this.consultaMovil.removeEventListener) {
      this.consultaMovil.removeEventListener('change', this.alCambiarVista);
    } else if (this.consultaMovil.removeListener) {
      this.consultaMovil.removeListener(this.alCambiarVista);
    }
  };
  function iniciarBarras(contexto) {
    var alcance = contexto && contexto.querySelectorAll ? contexto : document;
    var nodos = alcance.querySelectorAll('[data-seccion-anuncios]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccBarraAnuncios) continue;
      nodos[i].ccBarraAnuncios = new BarraAnuncios(nodos[i]);
    }
  }
  function arrancarTodo() {
    iniciarBarras(document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancarTodo);
  } else {
    arrancarTodo();
  }
  document.addEventListener('shopify:section:load', function (evento) {
    iniciarBarras(evento.target);
  });
  document.addEventListener('shopify:section:unload', function (evento) {
    var nodos = evento.target.querySelectorAll('[data-seccion-anuncios]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccBarraAnuncios) {
        nodos[i].ccBarraAnuncios.destruir();
        nodos[i].ccBarraAnuncios = null;
      }
    }
  });
  document.addEventListener('shopify:block:select', function (evento) {
    var raiz = evento.target.closest('[data-seccion-anuncios]');
    if (!raiz || !raiz.ccBarraAnuncios) return;
    var instancia = raiz.ccBarraAnuncios;
    var posicion = instancia.items.indexOf(evento.target);
    if (posicion === -1) return;
    instancia.detener();
    instancia.fijar(posicion);
  });
  document.addEventListener('shopify:block:deselect', function (evento) {
    var raiz = evento.target.closest('[data-seccion-anuncios]');
    if (!raiz || !raiz.ccBarraAnuncios) return;
    raiz.ccBarraAnuncios.evaluar();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-bestsellers"] && !Shopify.designMode) return;
  try {
    
(function () {
  function ColeccionDestacada(raiz) {
    this.raiz = raiz;
    this.pista = raiz.querySelector('[data-cc-cards-pista]');
    this.formularios = Array.prototype.slice.call(raiz.querySelectorAll('[data-cc-cards-form]'));
    this.botonAnterior = raiz.querySelector('[data-cc-cards-anterior]');
    this.botonSiguiente = raiz.querySelector('[data-cc-cards-siguiente]');
    this.urlAgregar = raiz.getAttribute('data-url-agregar');
    this.urlCarrito = raiz.getAttribute('data-url-carrito');
    this.iniciar();
  }

  ColeccionDestacada.prototype.iniciar = function () {
    var self = this;

    for (var i = 0; i < this.formularios.length; i++) {
      this.formularios[i].addEventListener('submit', function (evento) {
        self.agregar(evento);
      });
    }

    if (this.pista && (this.botonAnterior || this.botonSiguiente)) {
      if (this.botonAnterior) {
        this.botonAnterior.addEventListener('click', function () {
          self.desplazar(-1);
        });
      }

      if (this.botonSiguiente) {
        this.botonSiguiente.addEventListener('click', function () {
          self.desplazar(1);
        });
      }

      this.alDesplazar = function () {
        self.evaluarFlechas();
      };

      this.pista.addEventListener('scroll', this.alDesplazar, { passive: true });
      window.addEventListener('resize', this.alDesplazar);
      this.evaluarFlechas();
    }
  };

  ColeccionDestacada.prototype.desplazar = function (direccion) {
    var tarjeta = this.pista.querySelector('.cc-cards__item');
    var paso = tarjeta ? tarjeta.offsetWidth : this.pista.clientWidth;
    var separacion = parseFloat(window.getComputedStyle(this.pista).columnGap || '0') || 0;
    this.pista.scrollBy({ left: direccion * (paso + separacion), behavior: 'smooth' });
  };

  ColeccionDestacada.prototype.evaluarFlechas = function () {
    if (!this.pista) return;

    var margen = 4;
    var maximo = this.pista.scrollWidth - this.pista.clientWidth;

    if (this.botonAnterior) {
      this.botonAnterior.disabled = this.pista.scrollLeft <= margen;
    }

    if (this.botonSiguiente) {
      this.botonSiguiente.disabled = this.pista.scrollLeft >= maximo - margen;
    }
  };

  ColeccionDestacada.prototype.receptor = function () {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  };

  ColeccionDestacada.prototype.agregar = function (evento) {
    var receptor = this.receptor();
    if (!receptor || typeof receptor.renderContents !== 'function') return;

    evento.preventDefault();

    var self = this;
    var formulario = evento.currentTarget;
    var boton = formulario.querySelector('[data-cc-cards-boton]');
    var error = formulario.querySelector('[data-cc-cards-error]');

    if (boton && boton.classList.contains('esta-cargando')) return;

    if (error) {
      error.classList.remove('esta-visible');
      error.textContent = '';
    }

    if (boton) {
      boton.classList.add('esta-cargando');
      boton.setAttribute('aria-disabled', 'true');
    }

    var datos = new FormData(formulario);

    if (typeof receptor.getSectionsToRender === 'function') {
      var secciones = receptor.getSectionsToRender().map(function (seccion) {
        return seccion.id;
      });
      datos.append('sections', secciones);
      datos.append('sections_url', window.location.pathname);
    }

    if (typeof receptor.setActiveElement === 'function') {
      receptor.setActiveElement(document.activeElement);
    }

    fetch(this.urlAgregar, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: datos
    })
      .then(function (respuesta) {
        return respuesta.json();
      })
      .then(function (datosRespuesta) {
        if (datosRespuesta.status) {
          if (error) {
            error.textContent = datosRespuesta.description || datosRespuesta.message;
            error.classList.add('esta-visible');
          }
          return;
        }

        receptor.renderContents(datosRespuesta);
      })
      .catch(function () {
        window.location = self.urlCarrito;
      })
      .finally(function () {
        if (boton) {
          boton.classList.remove('esta-cargando');
          boton.removeAttribute('aria-disabled');
        }
      });
  };

  ColeccionDestacada.prototype.destruir = function () {
    if (this.alDesplazar) {
      window.removeEventListener('resize', this.alDesplazar);
    }
  };

  function iniciarColecciones(contexto) {
    var alcance = contexto && contexto.querySelectorAll ? contexto : document;
    var nodos = alcance.querySelectorAll('[data-cc-cards]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccCards) continue;
      nodos[i].ccCards = new ColeccionDestacada(nodos[i]);
    }
  }

  function arrancarTodo() {
    iniciarColecciones(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancarTodo);
  } else {
    arrancarTodo();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarColecciones(evento.target);
  });

  document.addEventListener('shopify:section:unload', function (evento) {
    var nodos = evento.target.querySelectorAll('[data-cc-cards]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccCards) {
        nodos[i].ccCards.destruir();
        nodos[i].ccCards = null;
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-coleccion-essentia"] && !Shopify.designMode) return;
  try {
    
(function () {
  function Familias(raiz) {
    this.raiz = raiz;
    this.pills = Array.prototype.slice.call(raiz.querySelectorAll('[data-cc-pill]'));
    this.tarjetas = Array.prototype.slice.call(raiz.querySelectorAll('[data-cc-tarjeta]'));
    this.sinResultados = raiz.querySelector('[data-cc-sin-resultados]');
    this.iniciar();
  }
  Familias.prototype.iniciar = function () {
    var self = this;
    for (var i = 0; i < this.pills.length; i++) {
      (function (pill) {
        pill.addEventListener('click', function () {
          self.filtrar(pill);
        });
      })(this.pills[i]);
    }
    var botones = this.raiz.querySelectorAll('[data-cc-agregar]');
    for (var j = 0; j < botones.length; j++) {
      (function (boton) {
        boton.addEventListener('click', function () {
          self.agregar(boton);
        });
      })(botones[j]);
    }
  };
  Familias.prototype.filtrar = function (pill) {
    var valor = pill.getAttribute('data-valor') || '';
    for (var i = 0; i < this.pills.length; i++) {
      var activa = this.pills[i] === pill;
      this.pills[i].classList.toggle('esta-activa', activa);
      this.pills[i].setAttribute('aria-pressed', activa ? 'true' : 'false');
    }
    var visibles = 0;
    for (var j = 0; j < this.tarjetas.length; j++) {
      var familias = this.tarjetas[j].getAttribute('data-familias') || '';
      var coincide = valor === '' || familias.indexOf(valor) !== -1;
      this.tarjetas[j].classList.toggle('esta-oculta', !coincide);
      if (coincide) visibles++;
    }
    if (this.sinResultados) {
      if (visibles === 0) {
        this.sinResultados.removeAttribute('hidden');
      } else {
        this.sinResultados.setAttribute('hidden', 'hidden');
      }
    }
  };
  Familias.prototype.agregar = function (boton) {
    var etiqueta = boton.querySelector('[data-cc-agregar-texto]');
    var variante = boton.getAttribute('data-variante');
    if (!variante) return;
    boton.classList.add('esta-cargando');
    var raizUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(raizUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variante, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('error');
        return r.json();
      })
      .then(function () {
        boton.classList.remove('esta-cargando');
        if (etiqueta) {
          etiqueta.textContent = boton.getAttribute('data-texto-agregado');
          window.setTimeout(function () {
            etiqueta.textContent = boton.getAttribute('data-texto-normal');
          }, 2200);
        }
        var espejo = document.getElementById('cart-icon-bubble');
        if (espejo) {
          fetch(window.location.pathname + '?section_id=cart-icon-bubble')
            .then(function (r) {
              return r.text();
            })
            .then(function (html) {
              var caja = document.createElement('div');
              caja.innerHTML = html;
              var nuevo = caja.querySelector('.shopify-section') || caja.firstElementChild;
              if (nuevo) espejo.innerHTML = nuevo.innerHTML;
            })
            .catch(function () {});
        }
        document.dispatchEvent(new CustomEvent('cc:carrito:actualizado'));
      })
      .catch(function () {
        boton.classList.remove('esta-cargando');
        if (etiqueta) {
          etiqueta.textContent = boton.getAttribute('data-texto-error');
          window.setTimeout(function () {
            etiqueta.textContent = boton.getAttribute('data-texto-normal');
          }, 2200);
        }
      });
  };
  function iniciarSecciones(contexto) {
    var alcance = contexto && contexto.querySelectorAll ? contexto : document;
    var nodos = alcance.querySelectorAll('[data-cc-familias]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccFamilias) continue;
      nodos[i].ccFamilias = new Familias(nodos[i]);
    }
  }
  function arrancarTodo() {
    iniciarSecciones(document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancarTodo);
  } else {
    arrancarTodo();
  }
  document.addEventListener('shopify:section:load', function (evento) {
    iniciarSecciones(evento.target);
  });
  document.addEventListener('shopify:section:unload', function (evento) {
    var nodos = evento.target.querySelectorAll('[data-cc-familias]');
    for (var i = 0; i < nodos.length; i++) {
      nodos[i].ccFamilias = null;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-cuadricula-coleccion-destacada"] && !Shopify.designMode) return;
  try {
    
(function () {
  function Cuadricula(raiz) {
    this.raiz = raiz;
    var self = this;
    var botones = raiz.querySelectorAll('[data-cc-agregar]');
    for (var i = 0; i < botones.length; i++) {
      (function (boton) {
        boton.addEventListener('click', function () {
          self.agregar(boton);
        });
      })(botones[i]);
    }
  }
  Cuadricula.prototype.agregar = function (boton) {
    var etiqueta = boton.querySelector('[data-cc-agregar-texto]');
    var variante = boton.getAttribute('data-variante');
    if (!variante) return;
    boton.classList.add('esta-cargando');
    var raizUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(raizUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variante, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('error');
        return r.json();
      })
      .then(function () {
        boton.classList.remove('esta-cargando');
        if (etiqueta) {
          etiqueta.textContent = boton.getAttribute('data-texto-agregado');
          window.setTimeout(function () {
            etiqueta.textContent = boton.getAttribute('data-texto-normal');
          }, 2200);
        }
        var espejo = document.getElementById('cart-icon-bubble');
        if (espejo) {
          fetch(window.location.pathname + '?section_id=cart-icon-bubble')
            .then(function (r) {
              return r.text();
            })
            .then(function (html) {
              var caja = document.createElement('div');
              caja.innerHTML = html;
              var nuevo = caja.querySelector('.shopify-section') || caja.firstElementChild;
              if (nuevo) espejo.innerHTML = nuevo.innerHTML;
            })
            .catch(function () {});
        }
        document.dispatchEvent(new CustomEvent('cc:carrito:actualizado'));
      })
      .catch(function () {
        boton.classList.remove('esta-cargando');
        if (etiqueta) {
          etiqueta.textContent = boton.getAttribute('data-texto-error');
          window.setTimeout(function () {
            etiqueta.textContent = boton.getAttribute('data-texto-normal');
          }, 2200);
        }
      });
  };
  function iniciarSecciones(contexto) {
    var alcance = contexto && contexto.querySelectorAll ? contexto : document;
    var nodos = alcance.querySelectorAll('[data-cc-cuadricula]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccCuadricula) continue;
      nodos[i].ccCuadricula = new Cuadricula(nodos[i]);
    }
  }
  function arrancarTodo() {
    iniciarSecciones(document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancarTodo);
  } else {
    arrancarTodo();
  }
  document.addEventListener('shopify:section:load', function (evento) {
    iniciarSecciones(evento.target);
  });
  document.addEventListener('shopify:section:unload', function (evento) {
    var nodos = evento.target.querySelectorAll('[data-cc-cuadricula]');
    for (var i = 0; i < nodos.length; i++) {
      nodos[i].ccCuadricula = null;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-cuadricula-coleccion"] && !Shopify.designMode) return;
  try {
    
(function () {
  function Coleccion(raiz) {
    this.raiz = raiz;
    this.seccion = raiz.getAttribute('data-seccion');
    this.urlAgregar = raiz.getAttribute('data-url-agregar');
    this.urlCarrito = raiz.getAttribute('data-url-carrito');
    this.velo = raiz.querySelector('[data-cc-col-velo]');
    this.cargando = false;
    this.raiz.classList.add('cc-col--js');
    this.enlazar();
  }

  Coleccion.prototype.enlazar = function () {
    var self = this;

    this.formFacetas = this.raiz.querySelector('[data-cc-col-form-facetas]');
    this.formOrden = this.raiz.querySelector('[data-cc-col-form-orden]');
    this.drawer = this.raiz.querySelector('.cc-col__drawer');

    if (this.formFacetas) {
      this.formFacetas.addEventListener('change', function (evento) {
        if (evento.target.type === 'number') return;
        self.aplicar();
      });

      this.formFacetas.addEventListener('submit', function (evento) {
        evento.preventDefault();
        self.aplicar();
      });

      var numeros = this.formFacetas.querySelectorAll('input[type="number"]');
      for (var n = 0; n < numeros.length; n++) {
        numeros[n].addEventListener('change', function () {
          self.aplicar();
        });
      }

      this.iniciarRango();
    }

    if (this.formOrden) {
      this.formOrden.addEventListener('change', function () {
        self.aplicar();
      });

      this.formOrden.addEventListener('submit', function (evento) {
        evento.preventDefault();
        self.aplicar();
      });
    }

    var abrir = this.raiz.querySelector('[data-cc-col-abrir]');
    if (abrir) {
      abrir.addEventListener('click', function () {
        self.abrirDrawer();
      });
    }

    var cierres = this.raiz.querySelectorAll('[data-cc-col-cerrar]');
    for (var c = 0; c < cierres.length; c++) {
      cierres[c].addEventListener('click', function () {
        self.cerrarDrawer();
      });
    }

    if (this.velo) {
      this.velo.addEventListener('click', function () {
        self.cerrarDrawer();
      });
    }

    this.alTeclear = function (evento) {
      if (evento.key === 'Escape') self.cerrarDrawer();
    };
    document.addEventListener('keydown', this.alTeclear);

    var formularios = this.raiz.querySelectorAll('[data-cc-col-form-add]');
    for (var i = 0; i < formularios.length; i++) {
      formularios[i].addEventListener('submit', function (evento) {
        self.agregar(evento);
      });
    }
  };

  Coleccion.prototype.iniciarRango = function () {
    var caja = this.raiz.querySelector('[data-cc-col-precio]');
    if (!caja) return;

    var self = this;
    var minR = caja.querySelector('[data-cc-col-rango-min]');
    var maxR = caja.querySelector('[data-cc-col-rango-max]');
    var minN = caja.querySelector('[data-cc-col-precio-min]');
    var maxN = caja.querySelector('[data-cc-col-precio-max]');
    var activo = caja.querySelector('[data-cc-col-rango-activo]');
    var tope = parseInt(caja.getAttribute('data-tope'), 10) || 100;

    if (!minR || !maxR) return;

    function pintar() {
      var a = parseInt(minR.value, 10);
      var b = parseInt(maxR.value, 10);
      if (activo) {
        activo.style.left = (a / tope) * 100 + '%';
        activo.style.right = 100 - (b / tope) * 100 + '%';
      }
    }

    minR.addEventListener('input', function () {
      if (parseInt(minR.value, 10) > parseInt(maxR.value, 10) - 1) {
        minR.value = parseInt(maxR.value, 10) - 1;
      }
      if (minN) minN.value = minR.value > 0 ? minR.value : '';
      pintar();
    });

    maxR.addEventListener('input', function () {
      if (parseInt(maxR.value, 10) < parseInt(minR.value, 10) + 1) {
        maxR.value = parseInt(minR.value, 10) + 1;
      }
      if (maxN) maxN.value = parseInt(maxR.value, 10) < tope ? maxR.value : '';
      pintar();
    });

    minR.addEventListener('change', function () {
      self.aplicar();
    });

    maxR.addEventListener('change', function () {
      self.aplicar();
    });

    if (minN) {
      minN.addEventListener('input', function () {
        minR.value = minN.value === '' ? 0 : minN.value;
        pintar();
      });
    }

    if (maxN) {
      maxN.addEventListener('input', function () {
        maxR.value = maxN.value === '' ? tope : maxN.value;
        pintar();
      });
    }

    pintar();
  };

  Coleccion.prototype.construirUrl = function () {
    var params = new URLSearchParams();

    if (this.formFacetas) {
      var datos = new FormData(this.formFacetas);
      datos.forEach(function (valor, clave) {
        if (valor !== '' && clave !== 'sort_by') params.append(clave, valor);
      });
    }

    if (this.formOrden) {
      var select = this.formOrden.querySelector('[name="sort_by"]');
      if (select && select.value) params.set('sort_by', select.value);
    } else if (this.formFacetas) {
      var espejo = this.formFacetas.querySelector('[data-cc-col-orden-espejo]');
      if (espejo && espejo.value) params.set('sort_by', espejo.value);
    }

    var cadena = params.toString();
    return window.location.pathname + (cadena ? '?' + cadena : '');
  };

  Coleccion.prototype.aplicar = function () {
    if (this.cargando) return;

    var self = this;
    var destino = this.construirUrl();
    var separador = destino.indexOf('?') > -1 ? '&' : '?';

    this.cargando = true;
    this.raiz.classList.add('esta-cargando');

    fetch(destino + separador + 'section_id=' + this.seccion)
      .then(function (respuesta) {
        return respuesta.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        self.intercambiar(doc, destino);
      })
      .catch(function () {
        window.location = destino;
      })
      .finally(function () {
        self.cargando = false;
        self.raiz.classList.remove('esta-cargando');
      });
  };

  Coleccion.prototype.intercambiar = function (doc, destino) {
    var abierto = this.drawer && this.drawer.classList.contains('esta-abierto');
    var abiertos = [];
    var cajas = this.raiz.querySelectorAll('.cc-col__fbox');
    for (var d = 0; d < cajas.length; d++) {
      abiertos.push(cajas[d].open);
    }

    var lateralNuevo = doc.querySelector('[data-cc-col-lateral]');
    var lateralViejo = this.raiz.querySelector('[data-cc-col-lateral]');
    if (lateralNuevo && lateralViejo) {
      lateralViejo.innerHTML = lateralNuevo.innerHTML;
    }

    var mainNuevo = doc.querySelector('[data-cc-col-main]');
    var mainViejo = this.raiz.querySelector('[data-cc-col-main]');
    if (mainNuevo && mainViejo) {
      mainViejo.innerHTML = mainNuevo.innerHTML;
    }

    window.history.replaceState({}, '', destino);

    this.enlazar();

    var cajasNuevas = this.raiz.querySelectorAll('.cc-col__fbox');
    for (var e = 0; e < cajasNuevas.length && e < abiertos.length; e++) {
      cajasNuevas[e].open = abiertos[e];
    }

    if (abierto) this.abrirDrawer();

    var main = this.raiz.querySelector('[data-cc-col-main]');
    if (main && window.innerWidth >= 990) {
      var arriba = main.getBoundingClientRect().top + window.pageYOffset - 100;
      if (window.pageYOffset > arriba) window.scrollTo({ top: arriba, behavior: 'smooth' });
    }
  };

  Coleccion.prototype.abrirDrawer = function () {
    if (!this.drawer || !this.velo) return;
    if (window.innerWidth >= 990) return;

    var self = this;
    this.velo.hidden = false;
    this.drawer.classList.add('esta-montado');
    document.body.style.overflow = 'hidden';

    window.requestAnimationFrame(function () {
      self.drawer.classList.add('esta-abierto');
      self.velo.classList.add('esta-abierto');
    });
  };

  Coleccion.prototype.cerrarDrawer = function () {
    if (!this.drawer || !this.velo) return;
    if (!this.drawer.classList.contains('esta-abierto')) return;

    var self = this;
    this.drawer.classList.remove('esta-abierto');
    this.velo.classList.remove('esta-abierto');
    document.body.style.overflow = '';

    window.setTimeout(function () {
      self.drawer.classList.remove('esta-montado');
      self.velo.hidden = true;
    }, 300);
  };

  Coleccion.prototype.receptor = function () {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  };

  Coleccion.prototype.agregar = function (evento) {
    var receptor = this.receptor();
    if (!receptor || typeof receptor.renderContents !== 'function') return;

    evento.preventDefault();

    var self = this;
    var formulario = evento.currentTarget;
    var boton = formulario.querySelector('[data-cc-col-add]');
    var error = formulario.querySelector('[data-cc-col-error]');

    if (boton && boton.classList.contains('esta-cargando')) return;

    if (error) {
      error.classList.remove('esta-visible');
      error.textContent = '';
    }

    if (boton) boton.classList.add('esta-cargando');

    var datos = new FormData(formulario);

    if (typeof receptor.getSectionsToRender === 'function') {
      var secciones = receptor.getSectionsToRender().map(function (s) {
        return s.id;
      });
      datos.append('sections', secciones);
      datos.append('sections_url', window.location.pathname);
    }

    if (typeof receptor.setActiveElement === 'function') {
      receptor.setActiveElement(document.activeElement);
    }

    fetch(this.urlAgregar, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: datos
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (d) {
        if (d.status) {
          if (error) {
            error.textContent = d.description || d.message;
            error.classList.add('esta-visible');
          }
          return;
        }
        receptor.renderContents(d);
      })
      .catch(function () {
        window.location = self.urlCarrito;
      })
      .finally(function () {
        if (boton) boton.classList.remove('esta-cargando');
      });
  };

  Coleccion.prototype.destruir = function () {
    document.removeEventListener('keydown', this.alTeclear);
    document.body.style.overflow = '';
  };

  function iniciar(contexto) {
    var alcance = contexto && contexto.querySelectorAll ? contexto : document;
    var nodos = alcance.querySelectorAll('[data-cc-col]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccCol) continue;
      nodos[i].ccCol = new Coleccion(nodos[i]);
    }
  }

  function arrancar() {
    iniciar(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  document.addEventListener('shopify:section:load', function (e) {
    iniciar(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var nodos = e.target.querySelectorAll('[data-cc-col]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccCol) {
        nodos[i].ccCol.destruir();
        nodos[i].ccCol = null;
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-filas-de-producto"] && !Shopify.designMode) return;
  try {
    
(function () {
  function CarruselFila(media) {
    this.media = media;
    this.slides = Array.prototype.slice.call(media.querySelectorAll('[data-cc-slide]'));
    this.anterior = media.querySelector('[data-cc-anterior]');
    this.siguiente = media.querySelector('[data-cc-siguiente]');
    this.contenedorPuntos = media.querySelector('[data-cc-puntos]');
    this.puntos = [];
    this.indice = 0;
    this.iniciar();
  }
  CarruselFila.prototype.iniciar = function () {
    var self = this;
    if (this.slides.length === 0) return;
    if (this.contenedorPuntos && this.slides.length > 1) {
      for (var i = 0; i < this.slides.length; i++) {
        var punto = document.createElement('button');
        punto.type = 'button';
        punto.className = 'cc-filas__punto';
        punto.setAttribute('aria-label', 'Ir al medio ' + (i + 1));
        (function (indice) {
          punto.addEventListener('click', function () {
            self.mostrar(indice);
          });
        })(i);
        this.contenedorPuntos.appendChild(punto);
        this.puntos.push(punto);
      }
    }
    if (this.anterior) {
      this.anterior.addEventListener('click', function () {
        self.mostrar(self.indice - 1);
      });
    }
    if (this.siguiente) {
      this.siguiente.addEventListener('click', function () {
        self.mostrar(self.indice + 1);
      });
    }
    this.mostrar(0);
  };
  CarruselFila.prototype.mostrar = function (indice) {
    this.indice = (indice + this.slides.length) % this.slides.length;
    for (var i = 0; i < this.slides.length; i++) {
      var esActivo = i === this.indice;
      this.slides[i].classList.toggle('esta-activo', esActivo);
      if (!esActivo) {
        var video = this.slides[i].querySelector('video');
        if (video && !video.paused) video.pause();
      }
    }
    for (var j = 0; j < this.puntos.length; j++) {
      this.puntos[j].classList.toggle('esta-activo', j === this.indice);
    }
  };
  function FilasColeccion(raiz) {
    this.raiz = raiz;
    this.carruseles = [];
    var medios = raiz.querySelectorAll('[data-cc-media]');
    for (var i = 0; i < medios.length; i++) {
      this.carruseles.push(new CarruselFila(medios[i]));
    }
  }
  function iniciarSecciones(contexto) {
    var alcance = contexto && contexto.querySelectorAll ? contexto : document;
    var nodos = alcance.querySelectorAll('[data-cc-filas]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccFilasColeccion) continue;
      nodos[i].ccFilasColeccion = new FilasColeccion(nodos[i]);
    }
  }
  function arrancarTodo() {
    iniciarSecciones(document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancarTodo);
  } else {
    arrancarTodo();
  }
  document.addEventListener('shopify:section:load', function (evento) {
    iniciarSecciones(evento.target);
  });
  document.addEventListener('shopify:section:unload', function (evento) {
    var nodos = evento.target.querySelectorAll('[data-cc-filas]');
    for (var i = 0; i < nodos.length; i++) {
      nodos[i].ccFilasColeccion = null;
    }
  });
  document.addEventListener('shopify:block:select', function (evento) {
    var fila = evento.target;
    if (!fila.hasAttribute || !fila.hasAttribute('data-cc-fila')) return;
    fila.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-hero-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function HeroCarrusel(raiz) {
    this.raiz = raiz;
    this.pista = raiz.querySelector('[data-cc-hero-pista]');
    this.slides = Array.prototype.slice.call(raiz.querySelectorAll('[data-cc-hero-slide]'));
    this.puntos = Array.prototype.slice.call(raiz.querySelectorAll('[data-cc-hero-punto]'));
    this.botonAnterior = raiz.querySelector('[data-cc-hero-anterior]');
    this.botonSiguiente = raiz.querySelector('[data-cc-hero-siguiente]');
    this.indice = 0;
    this.temporizador = null;
    this.autoplay = raiz.getAttribute('data-autoplay') === 'true';
    this.intervalo = Math.max(2000, parseFloat(raiz.getAttribute('data-intervalo') || '6.5') * 1000);
    this.reduccion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.inicioX = null;
    this.inicioY = null;
    this.iniciar();
  }

  HeroCarrusel.prototype.iniciar = function () {
    var self = this;

    if (this.slides.length < 2) {
      this.pintar();
      return;
    }

    if (this.botonAnterior) {
      this.botonAnterior.addEventListener('click', function () {
        self.mover(-1);
      });
    }

    if (this.botonSiguiente) {
      this.botonSiguiente.addEventListener('click', function () {
        self.mover(1);
      });
    }

    for (var i = 0; i < this.puntos.length; i++) {
      this.puntos[i].addEventListener('click', function (evento) {
        var destino = parseInt(evento.currentTarget.getAttribute('data-cc-hero-punto'), 10);
        self.ir(destino);
      });
    }

    this.raiz.addEventListener('mouseenter', function () {
      self.detener();
    });

    this.raiz.addEventListener('mouseleave', function () {
      self.evaluar();
    });

    this.raiz.addEventListener('focusin', function () {
      self.detener();
    });

    this.raiz.addEventListener('focusout', function () {
      self.evaluar();
    });

    this.raiz.addEventListener('touchstart', function (evento) {
      self.detener();
      self.inicioX = evento.touches[0].clientX;
      self.inicioY = evento.touches[0].clientY;
    }, { passive: true });

    this.raiz.addEventListener('touchend', function (evento) {
      if (self.inicioX === null) return;

      var finX = evento.changedTouches[0].clientX;
      var finY = evento.changedTouches[0].clientY;
      var deltaX = finX - self.inicioX;
      var deltaY = finY - self.inicioY;

      if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY)) {
        self.mover(deltaX < 0 ? 1 : -1);
      }

      self.inicioX = null;
      self.inicioY = null;
      self.evaluar();
    }, { passive: true });

    this.alPulsarTecla = function (evento) {
      if (!self.raiz.contains(document.activeElement)) return;
      if (evento.key === 'ArrowLeft') {
        evento.preventDefault();
        self.mover(-1);
      } else if (evento.key === 'ArrowRight') {
        evento.preventDefault();
        self.mover(1);
      }
    };

    document.addEventListener('keydown', this.alPulsarTecla);

    this.alCambiarVisibilidad = function () {
      if (document.hidden) {
        self.detener();
      } else {
        self.evaluar();
      }
    };

    document.addEventListener('visibilitychange', this.alCambiarVisibilidad);

    this.pintar();
    this.evaluar();
  };

  HeroCarrusel.prototype.pintar = function () {
    if (this.pista) {
      this.pista.style.transform = 'translateX(-' + this.indice * 100 + '%)';
    }

    for (var i = 0; i < this.slides.length; i++) {
      var esActivo = i === this.indice;
      this.slides[i].setAttribute('aria-hidden', esActivo ? 'false' : 'true');

      var enlaces = this.slides[i].querySelectorAll('a[href]');
      for (var k = 0; k < enlaces.length; k++) {
        if (esActivo) {
          enlaces[k].removeAttribute('tabindex');
        } else {
          enlaces[k].setAttribute('tabindex', '-1');
        }
      }
    }

    for (var j = 0; j < this.puntos.length; j++) {
      var activo = j === this.indice;
      this.puntos[j].classList.toggle('esta-activo', activo);
      this.puntos[j].setAttribute('aria-selected', activo ? 'true' : 'false');
    }
  };

  HeroCarrusel.prototype.ir = function (destino) {
    this.indice = (destino + this.slides.length) % this.slides.length;
    this.pintar();
    this.evaluar();
  };

  HeroCarrusel.prototype.mover = function (paso) {
    this.ir(this.indice + paso);
  };

  HeroCarrusel.prototype.arrancar = function () {
    var self = this;
    this.detener();
    this.temporizador = window.setInterval(function () {
      self.indice = (self.indice + 1) % self.slides.length;
      self.pintar();
    }, this.intervalo);
  };

  HeroCarrusel.prototype.detener = function () {
    if (this.temporizador) {
      window.clearInterval(this.temporizador);
      this.temporizador = null;
    }
  };

  HeroCarrusel.prototype.evaluar = function () {
    this.detener();

    if (!this.autoplay) return;
    if (this.slides.length < 2) return;
    if (this.reduccion.matches) return;
    if (window.Shopify && window.Shopify.designMode) return;

    this.arrancar();
  };

  HeroCarrusel.prototype.destruir = function () {
    this.detener();
    document.removeEventListener('keydown', this.alPulsarTecla);
    document.removeEventListener('visibilitychange', this.alCambiarVisibilidad);
  };

  function iniciarHeros(contexto) {
    var alcance = contexto && contexto.querySelectorAll ? contexto : document;
    var nodos = alcance.querySelectorAll('[data-cc-hero]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccHero) continue;
      nodos[i].ccHero = new HeroCarrusel(nodos[i]);
    }
  }

  function arrancarTodo() {
    iniciarHeros(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancarTodo);
  } else {
    arrancarTodo();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarHeros(evento.target);
  });

  document.addEventListener('shopify:section:unload', function (evento) {
    var nodos = evento.target.querySelectorAll('[data-cc-hero]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccHero) {
        nodos[i].ccHero.destruir();
        nodos[i].ccHero = null;
      }
    }
  });

  document.addEventListener('shopify:block:select', function (evento) {
    var raiz = evento.target.closest('[data-cc-hero]');
    if (!raiz || !raiz.ccHero) return;
    var instancia = raiz.ccHero;
    var posicion = instancia.slides.indexOf(evento.target);
    if (posicion === -1) return;
    instancia.detener();
    instancia.indice = posicion;
    instancia.pintar();
  });

  document.addEventListener('shopify:block:deselect', function (evento) {
    var raiz = evento.target.closest('[data-cc-hero]');
    if (!raiz || !raiz.ccHero) return;
    raiz.ccHero.evaluar();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-hero-imagenes"] && !Shopify.designMode) return;
  try {
    
(function () {
  function HeroImagenes(raiz) {
    this.raiz = raiz;
    this.pista = raiz.querySelector('[data-cc-heroimg-pista]');
    this.slides = Array.prototype.slice.call(raiz.querySelectorAll('[data-cc-heroimg-slide]'));
    this.puntos = Array.prototype.slice.call(raiz.querySelectorAll('[data-cc-heroimg-punto]'));
    this.botonAnterior = raiz.querySelector('[data-cc-heroimg-anterior]');
    this.botonSiguiente = raiz.querySelector('[data-cc-heroimg-siguiente]');
    this.indice = 0;
    this.temporizador = null;
    this.autoplay = raiz.getAttribute('data-autoplay') === 'true';
    this.intervalo = Math.max(2000, parseFloat(raiz.getAttribute('data-intervalo') || '6') * 1000);
    this.reduccion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.inicioX = null;
    this.inicioY = null;
    this.arrastrando = false;
    this.iniciar();
  }

  HeroImagenes.prototype.iniciar = function () {
    var self = this;

    if (this.slides.length < 2) {
      this.pintar();
      return;
    }

    if (this.botonAnterior) {
      this.botonAnterior.addEventListener('click', function () {
        self.mover(-1);
      });
    }

    if (this.botonSiguiente) {
      this.botonSiguiente.addEventListener('click', function () {
        self.mover(1);
      });
    }

    for (var i = 0; i < this.puntos.length; i++) {
      this.puntos[i].addEventListener('click', function (evento) {
        self.ir(parseInt(evento.currentTarget.getAttribute('data-cc-heroimg-punto'), 10));
      });
    }

    this.raiz.addEventListener('mouseenter', function () {
      self.detener();
    });

    this.raiz.addEventListener('mouseleave', function () {
      self.evaluar();
    });

    this.raiz.addEventListener('focusin', function () {
      self.detener();
    });

    this.raiz.addEventListener('focusout', function () {
      self.evaluar();
    });

    this.raiz.addEventListener('touchstart', function (evento) {
      self.detener();
      self.inicioX = evento.touches[0].clientX;
      self.inicioY = evento.touches[0].clientY;
      self.arrastrando = false;
    }, { passive: true });

    this.raiz.addEventListener('touchmove', function (evento) {
      if (self.inicioX === null) return;
      var dx = Math.abs(evento.touches[0].clientX - self.inicioX);
      var dy = Math.abs(evento.touches[0].clientY - self.inicioY);
      if (dx > 12 && dx > dy) self.arrastrando = true;
    }, { passive: true });

    this.raiz.addEventListener('touchend', function (evento) {
      if (self.inicioX === null) return;

      var deltaX = evento.changedTouches[0].clientX - self.inicioX;
      var deltaY = evento.changedTouches[0].clientY - self.inicioY;

      if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY)) {
        self.mover(deltaX < 0 ? 1 : -1);
      }

      self.inicioX = null;
      self.inicioY = null;
      self.evaluar();
    }, { passive: true });

    this.pista.addEventListener('click', function (evento) {
      if (!self.arrastrando) return;
      evento.preventDefault();
      self.arrastrando = false;
    });

    this.alPulsarTecla = function (evento) {
      if (!self.raiz.contains(document.activeElement)) return;
      if (evento.key === 'ArrowLeft') {
        evento.preventDefault();
        self.mover(-1);
      } else if (evento.key === 'ArrowRight') {
        evento.preventDefault();
        self.mover(1);
      }
    };

    document.addEventListener('keydown', this.alPulsarTecla);

    this.alCambiarVisibilidad = function () {
      if (document.hidden) {
        self.detener();
      } else {
        self.evaluar();
      }
    };

    document.addEventListener('visibilitychange', this.alCambiarVisibilidad);

    this.pintar();
    this.evaluar();
  };

  HeroImagenes.prototype.pintar = function () {
    if (this.pista) {
      this.pista.style.transform = 'translateX(-' + this.indice * 100 + '%)';
    }

    for (var i = 0; i < this.slides.length; i++) {
      var esActivo = i === this.indice;
      this.slides[i].setAttribute('aria-hidden', esActivo ? 'false' : 'true');

      if (this.slides[i].tagName === 'A') {
        if (esActivo) {
          this.slides[i].removeAttribute('tabindex');
        } else {
          this.slides[i].setAttribute('tabindex', '-1');
        }
      }
    }

    for (var j = 0; j < this.puntos.length; j++) {
      var activo = j === this.indice;
      this.puntos[j].classList.toggle('esta-activo', activo);
      this.puntos[j].setAttribute('aria-selected', activo ? 'true' : 'false');
    }
  };

  HeroImagenes.prototype.ir = function (destino) {
    this.indice = (destino + this.slides.length) % this.slides.length;
    this.pintar();
    this.evaluar();
  };

  HeroImagenes.prototype.mover = function (paso) {
    this.ir(this.indice + paso);
  };

  HeroImagenes.prototype.arrancar = function () {
    var self = this;
    this.detener();
    this.temporizador = window.setInterval(function () {
      self.indice = (self.indice + 1) % self.slides.length;
      self.pintar();
    }, this.intervalo);
  };

  HeroImagenes.prototype.detener = function () {
    if (this.temporizador) {
      window.clearInterval(this.temporizador);
      this.temporizador = null;
    }
  };

  HeroImagenes.prototype.evaluar = function () {
    this.detener();

    if (!this.autoplay) return;
    if (this.slides.length < 2) return;
    if (this.reduccion.matches) return;
    if (window.Shopify && window.Shopify.designMode) return;

    this.arrancar();
  };

  HeroImagenes.prototype.destruir = function () {
    this.detener();
    document.removeEventListener('keydown', this.alPulsarTecla);
    document.removeEventListener('visibilitychange', this.alCambiarVisibilidad);
  };

  function iniciarHeroImagenes(contexto) {
    var alcance = contexto && contexto.querySelectorAll ? contexto : document;
    var nodos = alcance.querySelectorAll('[data-cc-heroimg]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccHeroImagenes) continue;
      nodos[i].ccHeroImagenes = new HeroImagenes(nodos[i]);
    }
  }

  function arrancarTodo() {
    iniciarHeroImagenes(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancarTodo);
  } else {
    arrancarTodo();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarHeroImagenes(evento.target);
  });

  document.addEventListener('shopify:section:unload', function (evento) {
    var nodos = evento.target.querySelectorAll('[data-cc-heroimg]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccHeroImagenes) {
        nodos[i].ccHeroImagenes.destruir();
        nodos[i].ccHeroImagenes = null;
      }
    }
  });

  document.addEventListener('shopify:block:select', function (evento) {
    var raiz = evento.target.closest('[data-cc-heroimg]');
    if (!raiz || !raiz.ccHeroImagenes) return;
    var instancia = raiz.ccHeroImagenes;
    var posicion = instancia.slides.indexOf(evento.target);
    if (posicion === -1) return;
    instancia.detener();
    instancia.indice = posicion;
    instancia.pintar();
  });

  document.addEventListener('shopify:block:deselect', function (evento) {
    var raiz = evento.target.closest('[data-cc-heroimg]');
    if (!raiz || !raiz.ccHeroImagenes) return;
    raiz.ccHeroImagenes.evaluar();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function Producto(raiz) {
    this.raiz = raiz;
    this.urlProducto = raiz.getAttribute('data-url-producto');

    var nodoVariantes = raiz.querySelector('[data-cc-pdp-variantes]');
    var nodoTextos = raiz.querySelector('[data-cc-pdp-textos]');

    try {
      this.variantes = JSON.parse(nodoVariantes.textContent);
    } catch (e) {
      this.variantes = [];
    }

    try {
      this.textos = JSON.parse(nodoTextos.textContent);
    } catch (e) {
      this.textos = {};
    }

    this.formulario = raiz.querySelector('[data-cc-pdp-form]');
    this.campoId = raiz.querySelector('[data-cc-pdp-id]');
    this.opciones = Array.prototype.slice.call(raiz.querySelectorAll('[data-cc-pdp-opcion]'));
    this.iniciar();
  }

  Producto.prototype.iniciar = function () {
    var self = this;

    for (var i = 0; i < this.opciones.length; i++) {
      this.opciones[i].addEventListener('change', function () {
        self.alCambiarOpcion();
      });
    }

    var thumbs = this.raiz.querySelectorAll('[data-cc-pdp-thumb]');
    for (var t = 0; t < thumbs.length; t++) {
      thumbs[t].addEventListener('click', function (evento) {
        self.mostrarMedia(evento.currentTarget.getAttribute('data-media-id'));
      });
    }

    var menos = this.raiz.querySelector('[data-cc-pdp-menos]');
    var mas = this.raiz.querySelector('[data-cc-pdp-mas]');
    this.campoQty = this.raiz.querySelector('[data-cc-pdp-qty]');

    if (menos) {
      menos.addEventListener('click', function () {
        self.ajustarQty(-1);
      });
    }

    if (mas) {
      mas.addEventListener('click', function () {
        self.ajustarQty(1);
      });
    }

    if (this.formulario) {
      this.formulario.addEventListener('submit', function (evento) {
        self.agregar(evento);
      });
    }
  };

  Producto.prototype.ajustarQty = function (paso) {
    if (!this.campoQty) return;
    var actual = parseInt(this.campoQty.value, 10) || 1;
    var nuevo = actual + paso;
    if (nuevo < 1) nuevo = 1;
    this.campoQty.value = nuevo;
  };

  Producto.prototype.valoresElegidos = function () {
    var valores = [];
    for (var i = 0; i < this.opciones.length; i++) {
      var nodo = this.opciones[i];
      var indice = parseInt(nodo.getAttribute('data-indice'), 10);
      if (nodo.type === 'radio') {
        if (nodo.checked) valores[indice] = nodo.value;
      } else {
        valores[indice] = nodo.value;
      }
    }
    return valores;
  };

  Producto.prototype.buscarVariante = function (valores) {
    for (var i = 0; i < this.variantes.length; i++) {
      var v = this.variantes[i];
      var coincide = true;
      for (var j = 0; j < valores.length; j++) {
        if (v.options[j] !== valores[j]) {
          coincide = false;
          break;
        }
      }
      if (coincide) return v;
    }
    return null;
  };

  Producto.prototype.alCambiarOpcion = function () {
    var valores = this.valoresElegidos();
    var variante = this.buscarVariante(valores);

    for (var i = 0; i < valores.length; i++) {
      var etiqueta = this.raiz.querySelector('[data-cc-pdp-opcion-valor="' + i + '"]');
      if (etiqueta) etiqueta.textContent = valores[i];
    }

    if (!variante) {
      this.sinVariante();
      return;
    }

    this.aplicarVariante(variante);
  };

  Producto.prototype.sinVariante = function () {
    var boton = this.raiz.querySelector('[data-cc-pdp-add]');
    var texto = this.raiz.querySelector('[data-cc-pdp-add-texto]');
    if (boton) boton.disabled = true;
    if (texto) texto.textContent = this.textos.noDisponible || 'No disponible';
  };

  Producto.prototype.aplicarVariante = function (variante) {
    if (this.campoId) this.campoId.value = variante.id;

    var precio = this.raiz.querySelector('[data-cc-pdp-precio]');
    if (precio) precio.textContent = this.formatear(variante.price);

    var antes = this.raiz.querySelector('[data-cc-pdp-precio-antes]');
    if (antes) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        antes.textContent = this.formatear(variante.compare_at_price);
        antes.classList.remove('esta-oculto');
      } else {
        antes.classList.add('esta-oculto');
      }
    }

    var insignia = this.raiz.querySelector('[data-cc-pdp-insignia]');
    if (insignia) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        var pct = Math.round(((variante.compare_at_price - variante.price) * 100) / variante.compare_at_price);
        insignia.textContent = '-' + pct + '%';
        insignia.classList.remove('esta-oculto');
      } else {
        insignia.classList.add('esta-oculto');
      }
    }

    var cajaSku = this.raiz.querySelector('[data-cc-pdp-sku-caja]');
    var sku = this.raiz.querySelector('[data-cc-pdp-sku]');
    if (sku && cajaSku) {
      if (variante.sku) {
        sku.textContent = variante.sku;
        cajaSku.classList.remove('esta-oculto');
      } else {
        cajaSku.classList.add('esta-oculto');
      }
    }

    var cajaStock = this.raiz.querySelector('[data-cc-pdp-stock-caja]');
    var stock = this.raiz.querySelector('[data-cc-pdp-stock]');
    if (stock && cajaStock) {
      if (variante.available) {
        cajaStock.classList.remove('esta-agotado');
        var umbral = parseInt(this.textos.umbral, 10) || 0;
        if (variante.inventory_management && variante.inventory_policy === 'deny' && variante.inventory_quantity > 0 && variante.inventory_quantity <= umbral) {
          stock.textContent = (this.textos.stockBajo || '').replace('[n]', variante.inventory_quantity);
        } else {
          stock.textContent = this.textos.disponible || '';
        }
      } else {
        cajaStock.classList.add('esta-agotado');
        stock.textContent = this.textos.agotado || '';
      }
    }

    var boton = this.raiz.querySelector('[data-cc-pdp-add]');
    var texto = this.raiz.querySelector('[data-cc-pdp-add-texto]');
    if (boton) boton.disabled = !variante.available;
    if (texto) {
      texto.textContent = variante.available ? this.textos.agregar || '' : this.textos.agotado || '';
    }

    if (variante.featured_media && variante.featured_media.id) {
      this.mostrarMedia(String(variante.featured_media.id));
    }

    if (window.history.replaceState) {
      window.history.replaceState({}, '', this.urlProducto + '?variant=' + variante.id);
    }
  };

  Producto.prototype.formatear = function (centavos) {
    var valor = (centavos / 100).toFixed(2);
    var partes = valor.split('.');
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + partes.join('.');
  };

  Producto.prototype.mostrarMedia = function (id) {
    var lienzos = this.raiz.querySelectorAll('[data-cc-pdp-lienzo]');
    var thumbs = this.raiz.querySelectorAll('[data-cc-pdp-thumb]');
    var encontrado = false;

    for (var i = 0; i < lienzos.length; i++) {
      var activo = lienzos[i].getAttribute('data-media-id') === id;
      lienzos[i].classList.toggle('esta-activo', activo);
      if (activo) encontrado = true;
    }

    if (!encontrado && lienzos.length > 0) {
      lienzos[0].classList.add('esta-activo');
    }

    for (var t = 0; t < thumbs.length; t++) {
      thumbs[t].classList.toggle('esta-activo', thumbs[t].getAttribute('data-media-id') === id);
    }
  };

  Producto.prototype.receptor = function () {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  };

  Producto.prototype.agregar = function (evento) {
    var receptor = this.receptor();
    if (!receptor || typeof receptor.renderContents !== 'function') return;

    evento.preventDefault();

    var self = this;
    var boton = this.raiz.querySelector('[data-cc-pdp-add]');
    var error = this.raiz.querySelector('[data-cc-pdp-error]');

    if (boton && (boton.disabled || boton.classList.contains('esta-cargando'))) return;

    if (error) {
      error.classList.remove('esta-visible');
      error.textContent = '';
    }

    if (boton) boton.classList.add('esta-cargando');

    var datos = new FormData(this.formulario);

    if (typeof receptor.getSectionsToRender === 'function') {
      var secciones = receptor.getSectionsToRender().map(function (s) {
        return s.id;
      });
      datos.append('sections', secciones);
      datos.append('sections_url', window.location.pathname);
    }

    if (typeof receptor.setActiveElement === 'function') {
      receptor.setActiveElement(document.activeElement);
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: datos
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (d) {
        if (d.status) {
          if (error) {
            error.textContent = d.description || d.message;
            error.classList.add('esta-visible');
          }
          return;
        }
        receptor.renderContents(d);
      })
      .catch(function () {
        window.location = window.Shopify.routes.root + 'cart';
      })
      .finally(function () {
        if (boton) boton.classList.remove('esta-cargando');
      });
  };

  function iniciar(contexto) {
    var alcance = contexto && contexto.querySelectorAll ? contexto : document;
    var nodos = alcance.querySelectorAll('[data-cc-pdp]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccPdp) continue;
      nodos[i].ccPdp = new Producto(nodos[i]);
    }
  }

  function arrancar() {
    iniciar(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  document.addEventListener('shopify:section:load', function (e) {
    iniciar(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var nodos = e.target.querySelectorAll('[data-cc-pdp]');
    for (var i = 0; i < nodos.length; i++) {
      nodos[i].ccPdp = null;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function Resenas(raiz) {
    this.raiz = raiz;
    this.pista = raiz.querySelector('[data-cc-resenas-pista]');
    this.botonAnterior = raiz.querySelector('[data-cc-resenas-anterior]');
    this.botonSiguiente = raiz.querySelector('[data-cc-resenas-siguiente]');
    this.iniciar();
  }

  Resenas.prototype.iniciar = function () {
    var self = this;
    if (!this.pista) return;
    if (!this.botonAnterior && !this.botonSiguiente) return;

    if (this.botonAnterior) {
      this.botonAnterior.addEventListener('click', function () {
        self.desplazar(-1);
      });
    }

    if (this.botonSiguiente) {
      this.botonSiguiente.addEventListener('click', function () {
        self.desplazar(1);
      });
    }

    this.alDesplazar = function () {
      self.evaluarFlechas();
    };

    this.pista.addEventListener('scroll', this.alDesplazar, { passive: true });
    window.addEventListener('resize', this.alDesplazar);
    this.evaluarFlechas();
  };

  Resenas.prototype.desplazar = function (direccion) {
    var tarjeta = this.pista.querySelector('.cc-resenas__item');
    var paso = tarjeta ? tarjeta.offsetWidth : this.pista.clientWidth;
    var separacion = parseFloat(window.getComputedStyle(this.pista).columnGap || '0') || 0;
    this.pista.scrollBy({ left: direccion * (paso + separacion), behavior: 'smooth' });
  };

  Resenas.prototype.evaluarFlechas = function () {
    if (!this.pista) return;

    var margen = 4;
    var maximo = this.pista.scrollWidth - this.pista.clientWidth;

    if (this.botonAnterior) {
      this.botonAnterior.disabled = this.pista.scrollLeft <= margen;
    }

    if (this.botonSiguiente) {
      this.botonSiguiente.disabled = this.pista.scrollLeft >= maximo - margen;
    }
  };

  Resenas.prototype.destruir = function () {
    if (this.alDesplazar) {
      window.removeEventListener('resize', this.alDesplazar);
    }
  };

  function iniciarResenas(contexto) {
    var alcance = contexto && contexto.querySelectorAll ? contexto : document;
    var nodos = alcance.querySelectorAll('[data-cc-resenas]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccResenas) continue;
      nodos[i].ccResenas = new Resenas(nodos[i]);
    }
  }

  function arrancarTodo() {
    iniciarResenas(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancarTodo);
  } else {
    arrancarTodo();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarResenas(evento.target);
  });

  document.addEventListener('shopify:section:unload', function (evento) {
    var nodos = evento.target.querySelectorAll('[data-cc-resenas]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccResenas) {
        nodos[i].ccResenas.destruir();
        nodos[i].ccResenas = null;
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-video-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function VideoDestacado(raiz) {
    this.raiz = raiz;
    this.fuente = raiz.getAttribute('data-fuente');
    this.url = raiz.getAttribute('data-url');
    this.titulo = raiz.getAttribute('data-titulo') || 'Video';
    this.portada = raiz.querySelector('[data-cc-video-abrir]');
    this.reproductor = raiz.querySelector('[data-cc-video-reproductor]');
    this.activo = false;
    this.iniciar();
  }

  VideoDestacado.prototype.iniciar = function () {
    var self = this;
    if (!this.portada || !this.reproductor) return;
    if (this.fuente === 'ninguna') return;

    this.portada.addEventListener('click', function () {
      self.abrir();
    });
  };

  VideoDestacado.prototype.abrir = function () {
    if (this.activo) return;
    this.activo = true;

    if (this.fuente === 'externo') {
      this.montarIframe();
    } else {
      this.reproducirNativo();
    }

    this.reproductor.classList.add('cc-video__reproductor--visible');
    this.portada.classList.add('esta-oculta');
    this.portada.setAttribute('aria-hidden', 'true');
    this.portada.setAttribute('tabindex', '-1');
  };

  VideoDestacado.prototype.montarIframe = function () {
    if (!this.url) return;

    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', this.url);
    iframe.setAttribute('title', this.titulo);
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    iframe.setAttribute('allowfullscreen', 'true');
    iframe.setAttribute('loading', 'lazy');

    this.reproductor.appendChild(iframe);
    iframe.focus();
  };

  VideoDestacado.prototype.reproducirNativo = function () {
    var video = this.reproductor.querySelector('video');
    if (!video) return;

    video.setAttribute('controls', 'controls');
    video.setAttribute('playsinline', 'playsinline');
    video.setAttribute('preload', 'auto');

    var promesa = video.play();
    if (promesa && typeof promesa.catch === 'function') {
      promesa.catch(function () {});
    }

    video.focus();
  };

  VideoDestacado.prototype.destruir = function () {
    if (this.fuente === 'externo' && this.reproductor) {
      this.reproductor.innerHTML = '';
    } else if (this.reproductor) {
      var video = this.reproductor.querySelector('video');
      if (video && typeof video.pause === 'function') video.pause();
    }
  };

  function iniciarVideos(contexto) {
    var alcance = contexto && contexto.querySelectorAll ? contexto : document;
    var nodos = alcance.querySelectorAll('[data-cc-video]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccVideo) continue;
      nodos[i].ccVideo = new VideoDestacado(nodos[i]);
    }
  }

  function arrancarTodo() {
    iniciarVideos(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancarTodo);
  } else {
    arrancarTodo();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarVideos(evento.target);
  });

  document.addEventListener('shopify:section:unload', function (evento) {
    var nodos = evento.target.querySelectorAll('[data-cc-video]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccVideo) {
        nodos[i].ccVideo.destruir();
        nodos[i].ccVideo = null;
      }
    }
  });

  document.addEventListener('shopify:section:deselect', function (evento) {
    var nodos = evento.target.querySelectorAll('[data-cc-video]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccVideo) nodos[i].ccVideo.destruir();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-videos-tutoriales-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  function Videos(raiz) {
    this.raiz = raiz;
    var self = this;
    var disparadores = raiz.querySelectorAll('[data-cc-disparador]');
    for (var i = 0; i < disparadores.length; i++) {
      (function (boton) {
        boton.addEventListener('click', function () {
          self.reproducir(boton);
        });
      })(disparadores[i]);
    }
  }
  Videos.prototype.reproducir = function (boton) {
    var media = boton.closest('[data-cc-media]');
    if (!media) return;
    var plantilla = media.querySelector('[data-cc-plantilla]');
    if (!plantilla) return;
    this.detenerOtros(media);
    var contenido = plantilla.content.cloneNode(true);
    media.appendChild(contenido);
    boton.setAttribute('hidden', 'hidden');
    var nativo = media.querySelector('video');
    if (nativo && nativo.play) {
      var intento = nativo.play();
      if (intento && intento.catch) intento.catch(function () {});
    }
  };
  Videos.prototype.detenerOtros = function (actual) {
    var medios = this.raiz.querySelectorAll('[data-cc-media]');
    for (var i = 0; i < medios.length; i++) {
      if (medios[i] === actual) continue;
      var marco = medios[i].querySelector('iframe, video');
      if (!marco) continue;
      marco.parentNode.removeChild(marco);
      var boton = medios[i].querySelector('[data-cc-disparador]');
      if (boton) boton.removeAttribute('hidden');
    }
  };
  function iniciarSecciones(contexto) {
    var alcance = contexto && contexto.querySelectorAll ? contexto : document;
    var nodos = alcance.querySelectorAll('[data-cc-videos]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccVideos) continue;
      nodos[i].ccVideos = new Videos(nodos[i]);
    }
  }
  function arrancarTodo() {
    iniciarSecciones(document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancarTodo);
  } else {
    arrancarTodo();
  }
  document.addEventListener('shopify:section:load', function (evento) {
    iniciarSecciones(evento.target);
  });
  document.addEventListener('shopify:section:unload', function (evento) {
    var nodos = evento.target.querySelectorAll('[data-cc-videos]');
    for (var i = 0; i < nodos.length; i++) {
      nodos[i].ccVideos = null;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  function formatearDinero(centavos, formato) {
    function separar(numero, decimales, miles, decimal) {
      if (isNaN(numero) || numero === null) return '0';
      var fijo = (numero / 100.0).toFixed(decimales);
      var partes = fijo.split('.');
      var entero = partes[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + miles);
      var resto = partes[1] ? decimal + partes[1] : '';
      return entero + resto;
    }
    var salida = formato || '${{amount}}';
    var patron = /\{\{\s*(\w+)\s*\}\}/;
    var coincide = salida.match(patron);
    if (!coincide) return salida;
    var valor = '';
    switch (coincide[1]) {
      case 'amount':
        valor = separar(centavos, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        valor = separar(centavos, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        valor = separar(centavos, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        valor = separar(centavos, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        valor = separar(centavos, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        valor = separar(centavos, 0, ' ', ',');
        break;
      case 'amount_with_apostrophe_separator':
        valor = separar(centavos, 2, "'", '.');
        break;
      default:
        valor = separar(centavos, 2, ',', '.');
    }
    return salida.replace(patron, valor);
  }
  function escapar(texto) {
    var caja = document.createElement('div');
    caja.textContent = texto == null ? '' : String(texto);
    return caja.innerHTML;
  }
  function redimensionar(url, tamano) {
    if (!url) return '';
    return url.replace(/(\.(png|jpe?g|webp|gif))(\?.*)?$/i, '_' + tamano + '$1$3');
  }
  function Encabezado(raiz) {
    this.raiz = raiz;
    this.seccion = raiz.closest('.cc-encabezado-seccion');
    this.botonAbrir = raiz.querySelector('[data-cc-abrir-drawer]');
    this.drawer = this.botonAbrir
      ? document.getElementById(this.botonAbrir.getAttribute('aria-controls'))
      : null;
    this.buscador = raiz.querySelector('[data-cc-buscador]');
    this.botonBuscadorMovil = raiz.querySelector('[data-cc-buscador-movil]');
    this.conteo = raiz.querySelector('[data-cc-carrito-conteo]');
    this.espejo = raiz.querySelector('#cart-icon-bubble');
    this.modoFijo = raiz.getAttribute('data-fijar');
    this.formatoDinero = raiz.getAttribute('data-formato-dinero') || '${{amount}}';
    this.ultimoScroll = window.pageYOffset || 0;
    this.observador = null;
    this.temporizadorDrawer = null;
    this.temporizadorSug = null;
    this.peticion = null;
    this.marcado = -1;
    this.resultados = [];
    this.consultaDesktop = window.matchMedia('(min-width: 990px)');
    this.iniciar();
  }
  Encabezado.prototype.iniciar = function () {
    var self = this;
    this.aplicarFijado();
    if (this.botonAbrir && this.drawer) {
      this.botonAbrir.addEventListener('click', function () {
        self.abrirDrawer();
      });
      var cierres = this.drawer.querySelectorAll('[data-cc-cerrar-drawer]');
      for (var i = 0; i < cierres.length; i++) {
        cierres[i].addEventListener('click', function () {
          self.cerrarDrawer(true);
        });
      }
      var enlaces = this.drawer.querySelectorAll('a[href]');
      for (var j = 0; j < enlaces.length; j++) {
        enlaces[j].addEventListener('click', function () {
          self.cerrarDrawer(false);
        });
      }
    }
    if (this.buscador) {
      this.buscador.addEventListener('submit', function (evento) {
        self.enviarBusqueda(evento);
      });
      this.iniciarSugerencias();
}
if (this.botonBuscadorMovil && this.buscador) {
  this.botonBuscadorMovil.addEventListener('click', function () {
    var abierto = self.raiz.classList.toggle('cc-buscador-movil-abierto');
self.botonBuscadorMovil.setAttribute('aria-expanded', String(abierto));

if (!abierto) {
  self.cerrarPanel();
  self.botonBuscadorMovil.focus();
  return;
}

    var campo = self.buscador.querySelector('.cc-encabezado__buscador-campo');
    if (campo) {
      setTimeout(function () {
        campo.focus();
      }, 50);
    }
  });
}

    this.alPulsarTecla = function (evento) {
      if (evento.key !== 'Escape' && evento.keyCode !== 27) return;
      if (self.drawer && self.drawer.classList.contains('esta-abierto')) {
        self.cerrarDrawer(true);
        return;
      }
      if (self.panel && !self.panel.hidden) {
        self.cerrarPanel();
        return;
      }
      var activo = document.activeElement;
      if (activo && self.raiz.contains(activo) && activo.blur) {
        activo.blur();
      }
    };
    document.addEventListener('keydown', this.alPulsarTecla);
    this.alCambiarVista = function (evento) {
      if (evento.matches) self.cerrarDrawer(false);
    };
    if (this.consultaDesktop.addEventListener) {
      this.consultaDesktop.addEventListener('change', this.alCambiarVista);
    } else if (this.consultaDesktop.addListener) {
      this.consultaDesktop.addListener(this.alCambiarVista);
    }
    if (this.modoFijo === 'al-subir') {
      this.alHacerScroll = function () {
        self.evaluarScroll();
      };
      window.addEventListener('scroll', this.alHacerScroll, { passive: true });
    }
    this.sincronizarCarrito();
  };
  Encabezado.prototype.iniciarSugerencias = function () {
    if (this.buscador.getAttribute('data-sug-activo') !== 'true') return;
    this.panel = this.buscador.querySelector('[data-cc-sug]');
    this.cuerpoSug = this.buscador.querySelector('[data-cc-sug-cuerpo]');
    this.aviso = this.buscador.querySelector('[data-cc-sug-aviso]');
    this.campo = this.buscador.querySelector('[data-cc-buscador-campo]');
    if (!this.panel || !this.campo) return;
    var nodoTextos = document.querySelector('[data-cc-sug-textos]');
    try {
      this.textos = JSON.parse(nodoTextos.textContent);
    } catch (e) {
      this.textos = {};
    }
    this.tipos = this.buscador.getAttribute('data-sug-tipos') || 'product';
    this.limite = parseInt(this.buscador.getAttribute('data-sug-limite'), 10) || 6;
    this.minimo = parseInt(this.buscador.getAttribute('data-sug-minimo'), 10) || 2;
    this.conPrecio = this.buscador.getAttribute('data-sug-precio') === 'true';
    var self = this;
    this.campo.addEventListener('input', function () {
      self.programar();
    });
    this.campo.addEventListener('focus', function () {
      if (self.campo.value.trim().length >= self.minimo && self.cuerpoSug.innerHTML !== '') {
        self.abrirPanel();
      }
    });
    this.campo.addEventListener('keydown', function (evento) {
      self.navegar(evento);
    });
    this.alClicFuera = function (evento) {
      if (!self.buscador.contains(evento.target)) self.cerrarPanel();
    };
    document.addEventListener('click', this.alClicFuera);
  };
    Encabezado.prototype.programar = function () {
    var self = this;
    window.clearTimeout(this.temporizadorSug);
    var termino = this.campo.value.trim();
    if (termino.length < this.minimo) {
      this.cerrarPanel();
      this.cuerpoSug.innerHTML = '';
      return;
    }
    this.pintar({ resources: { results: {} } }, termino);
    this.temporizadorSug = window.setTimeout(function () {
      self.consultar(termino);
    }, 260);
  };

  Encabezado.prototype.consultar = function (termino) {
    var self = this;
    if (this.peticion && this.peticion.abort) this.peticion.abort();
    var raiz = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var url =
      raiz +
      'search/suggest.json?q=' +
      encodeURIComponent(termino) +
      '&resources[type]=' +
      this.tipos +
      '&resources[limit]=' +
      this.limite +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,vendor,product_type,tag,variants.title,variants.sku';
    var controlador = window.AbortController ? new window.AbortController() : null;
    this.peticion = controlador;
    fetch(url, controlador ? { signal: controlador.signal } : undefined)
      .then(function (r) {
        return r.json();
      })
      .then(function (datos) {
        if (self.campo.value.trim() === termino) self.pintar(datos, termino);
      })
      .catch(function () {});
  };

  Encabezado.prototype.buscarDestinos = function (termino) {
    function normalizar(s) {
      return String(s || '').toLowerCase().normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]/g, '');
    }

    var destinos = [
      {title: 'Savage', url: '/pages/savage-de-nude', aliases: []},
      {title: 'Finesse', url: '/pages/finesse-de-nude', aliases: []},
      {title: 'Memento Mori', url: '/pages/memento-mori-de-nude', aliases: []},
      {title: 'Shade', url: '/pages/shade-de-nude', aliases: []},
      {title: 'Gabriel-Glas', url: '/pages/gabriel-glas', aliases: []},
      {title: 'NUDE', url: '/pages/nude', aliases: ['nude glass']},
      {title: 'Stem Zero', url: '/pages/stem-zero', aliases: []},
      {title: 'Hard Strong', url: '/pages/hard-strong', aliases: []},
      {title: 'Bar/Giani', url: '/pages/bar-giani', aliases: []},
      {title: 'Denver & Liely', url: '/pages/denver-liely', aliases: []},
      {title: 'Stündenglass', url: '/pages/stundenglass', aliases: []},
      {title: 'Flavour Blaster', url: '/pages/flavour-blaster', aliases: ['flavor blaster']},
      {title: 'Essentia', url: '/pages/esencias-para-cocteles-santa-bianca', aliases: ['santa bianca']},
      {title: 'Cocktail Kingdom', url: '/pages/cocktail-kingdom', aliases: []},
      {title: 'Viski', url: '/pages/viski', aliases: []},
      {title: 'Hornos de pizza Everdure KILN', url: '/pages/hornos-de-pizza-everdure-kiln', aliases: ['pizza', 'pizzas', 'kiln', 'kiln r', 'everdure', 'horno', 'hornos', 'horno de pizza', 'hornos de pizza', 'horno para pizza', 'hornos para pizzas']},
      {title: 'Coravin', url: '/pages/coravin', aliases: []},
      {title: 'Coravin Timeless', url: '/pages/coravin-timeless', aliases: ['timeless']},
      {title: 'Coravin Profesional', url: '/pages/coravin-pro-acceso', aliases: ['coravin pro']},
      {title: 'Academia Cantina Tuls', url: '/pages/academia-cantina-tuls', aliases: ['academia', 'libro', 'libros']},
      {title: 'Bartender Basics', url: '/pages/bartender-basics', aliases: []},
      {title: 'Máximo & Frida', url: '/pages/myf', aliases: ['myf', 'm&f']},
      {title: 'Mixing Glasses', url: '/pages/mixing-glasses', aliases: ['mixing glass']},
      {title: 'Jiggers', url: '/pages/jiggers', aliases: ['jigger']},
      {title: 'Coladores', url: '/pages/coladores', aliases: ['colador']},
      {title: 'Hielos', url: '/pages/hielos', aliases: ['hielo']},
      {title: 'Garnituras', url: '/pages/garnituras', aliases: ['garnitura']},
      {title: 'Vasos', url: '/pages/vasos', aliases: ['vaso']},
      {title: 'Copas para Cocteles', url: '/pages/copas-para-cocteles', aliases: ['copa de coctel', 'copas de coctel']},
      {title: 'Copas para Vino', url: '/pages/copas-para-vino', aliases: ['copa de vino', 'copas de vino']},
      {title: 'Destilados y Cerveza', url: '/pages/destilados-cerveza', aliases: ['destilado', 'destilados', 'tequila', 'mezcal', 'cerveza']},
      {title: 'Tikis, Mules y Juleps', url: '/pages/tikis-mules-y-juleps', aliases: ['tiki', 'tikis', 'mule', 'mules', 'julep', 'juleps']},
      {title: 'Garrafas, Decantadores y Licoreras', url: '/pages/garrafas-decantadores-y-licoreras', aliases: ['garrafa', 'garrafas', 'decantador', 'decantadores', 'licorera', 'licoreras']},
      {title: 'Servicio y Decoración', url: '/pages/servicio-y-decoracion', aliases: []},
      {title: 'Whisky y Puros', url: '/pages/whisky-y-puros', aliases: ['whisky', 'puros']},
      {title: 'Estilo Cantinero', url: '/pages/estilo-cantinero', aliases: ['roll up', 'roll ups', 'rollup', 'rollups', 'mochila', 'mochilas']},
      {title: 'Shakers', url: '/collections/shakers', aliases: ['shaker']}
    ];

    destinos.push({
      title: 'Cristalería',
      url: '/pages/cristaleria',
      aliases: ['copa', 'copas', 'cristaleria']
    });

    var paginasAdicionales = [ 
    ];

    paginasAdicionales.forEach(function (p) {
      var n = normalizar(p.title);
      if (n === 'cristaleria' || n === 'todocristaleria' || n === 'todalamcristaleria' || n === 'todalacristaleria') {
        destinos.push({
          title: p.title,
          url: p.url,
          aliases: ['copa', 'copas', 'cristaleria']
        });
      } else if (/barspoon|cucharasdebar/.test(n)) {
        destinos.push({
          title: p.title,
          url: p.url,
          aliases: ['barspoon', 'barspoons', 'bar spoon', 'bar spoons', 'cuchara de bar', 'cucharas de bar']
        });
      } else if (/hielera/.test(n)) {
        destinos.push({
          title: p.title,
          url: p.url,
          aliases: ['hielera', 'hieleras', 'wine chiller']
        });
      }
    });

    var texto = normalizar(termino);
    if (texto.length < 2) return [];

    var mejor = 0;
    var encontrados = [];

    destinos.forEach(function (d) {
      var puntaje = 0;

      [d.title].concat(d.aliases || []).forEach(function (nombre) {
        var n = normalizar(nombre);

        if (n === texto) {
          puntaje = Math.max(puntaje, 10000 + n.length);
        } else if (n.length >= 3 && texto.indexOf(n) !== -1) {
          puntaje = Math.max(puntaje, 1000 + n.length);
        } else if (n.indexOf(texto) === 0) {
          puntaje = Math.max(puntaje, 100);
        }
      });

      if (puntaje > mejor) {
        mejor = puntaje;
        encontrados = [];
      }

      if (puntaje && puntaje === mejor &&
          !encontrados.some(function (p) {
            return p.url === d.url;
          })) {
        encontrados.push(d);
      }
    });

    return encontrados;
  };

  Encabezado.prototype.pintar = function (datos, termino) {
    var res = datos && datos.resources && datos.resources.results ? datos.resources.results : {};
    var productos = res.products || [];
    var colecciones = res.collections || [];
    var consultas = res.queries || [];
    var busqueda = termino.trim().toLowerCase();

    var destinos = this.buscarDestinos(termino);
    var html = '';
    this.resultados = [];
    this.marcado = -1;
    this.campo.removeAttribute('aria-activedescendant');

    if (destinos.length) {
      html += '<div class="cc-encabezado__sug-grupo"><span class="cc-encabezado__sug-titulo">Explorar</span>';
      destinos.forEach(function (d) {
        html += '<a class="cc-encabezado__sug-simple" href="' +
          escapar(d.url) + '" role="option"><span>' +
          escapar(d.title) + '</span></a>';
      });
      html += '</div>';
    }

    if (destinos.length === 0 && productos.length === 0 &&
        colecciones.length === 0 && consultas.length === 0) {
      html =
        '<p class="cc-encabezado__sug-estado">' +
        escapar(this.textos.vacio || 'Sin resultados para') +
        ' “' +
        escapar(termino) +
        '”</p>';
      this.cuerpoSug.innerHTML = html;
      this.abrirPanel();
      this.anunciar(0);
      return;
    }

    if (consultas.length > 0) {
      html += '<div class="cc-encabezado__sug-grupo">';
      html += '<span class="cc-encabezado__sug-titulo">' +
        escapar(this.textos.consultas || '') + '</span>';
      for (var q = 0; q < consultas.length; q++) {
        html +=
          '<a class="cc-encabezado__sug-simple" href="' +
          escapar(consultas[q].url) +
          '" role="option">' +
          '<svg class="cc-encabezado__sug-lupa" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>' +
          '<span>' +
          escapar(consultas[q].text) +
          '</span></a>';
      }
      html += '</div>';
    }

    if (productos.length > 0) {
      html += '<div class="cc-encabezado__sug-grupo">';
      html += '<span class="cc-encabezado__sug-titulo">' +
        escapar(this.textos.productos || '') + '</span>';

      for (var p = 0; p < productos.length; p++) {
        var prod = productos[p];
        var enlaceProducto = prod.url;
        var textoProducto = (prod.title || '') + ' ' + (prod.vendor || '');

        if (/coravin/i.test(textoProducto) &&
            /\bpro\b|profesional/i.test(textoProducto)) {
          enlaceProducto = '/pages/coravin-pro-acceso';
        }

        var imagen = '';
        if (prod.featured_image && prod.featured_image.url) {
          imagen = prod.featured_image.url;
        } else if (prod.image) {
          imagen = prod.image;
        }

        html += '<a class="cc-encabezado__sug-item" href="' +
          escapar(enlaceProducto) + '" role="option">';

        if (imagen) {
          html +=
            '<img class="cc-encabezado__sug-img" src="' +
            escapar(redimensionar(imagen, '160x')) +
            '" alt="" loading="lazy" width="52" height="52">';
        }

        html += '<span class="cc-encabezado__sug-datos">';
        if (prod.vendor) {
          html += '<span class="cc-encabezado__sug-marca">' +
            escapar(prod.vendor) + '</span>';
        }

        html += '<span class="cc-encabezado__sug-nombre">' +
          escapar(prod.title) + '</span>';
        html += '</span>';

        if (prod.available === false) {
          html += '<span class="cc-encabezado__sug-agotado">Agotado</span>';
        } else if (this.conPrecio && prod.price !== undefined && prod.price !== null) {
          html += '<span class="cc-encabezado__sug-precio">';
          var precioCentavos = Math.round(parseFloat(prod.price) * 100);
          html += '<b>' +
            escapar(formatearDinero(precioCentavos, this.formatoDinero)) +
            '</b>';
          var antesCentavos = Math.round(parseFloat(prod.compare_at_price) * 100);

          if (antesCentavos && antesCentavos > precioCentavos) {
            html += '<s>' +
              escapar(formatearDinero(antesCentavos, this.formatoDinero)) +
              '</s>';
          }
          html += '</span>';
        }

        html += '</a>';
      }
      html += '</div>';
    }

    if (colecciones.length > 0) {
      html += '<div class="cc-encabezado__sug-grupo">';
      html += '<span class="cc-encabezado__sug-titulo">' +
        escapar(this.textos.colecciones || '') + '</span>';

      for (var c = 0; c < colecciones.length; c++) {
        var enlaceColeccion = colecciones[c].url;
        var nombreColeccion = colecciones[c].title.trim().toLowerCase();

        if (/st[üu]ndenglas/i.test(nombreColeccion)) {
          enlaceColeccion = '/pages/stundenglass';
        } else if (/flavou?r[\s-]*blaster/i.test(nombreColeccion)) {
          enlaceColeccion = '/pages/flavour-blaster';
        } else if (/essentia|santa[\s-]*bianca/i.test(nombreColeccion)) {
          enlaceColeccion = '/pages/esencias-para-cocteles-santa-bianca';
          colecciones[c].title = 'Essentia';
        } else if (/cocktail[\s-]*kingdom/i.test(nombreColeccion)) {
          enlaceColeccion = '/pages/cocktail-kingdom';
        } else if (/^viski$/i.test(nombreColeccion)) {
          enlaceColeccion = '/pages/viski';
        } else if (/savage/i.test(nombreColeccion)) {
          enlaceColeccion = '/pages/savage-de-nude';
        } else if (/academia/i.test(nombreColeccion)) {
          enlaceColeccion = '/pages/academia-cantina-tuls';
        } else if (/bar[\s\/-]*giani|bargiani/i.test(nombreColeccion)) {
          enlaceColeccion = '/pages/bar-giani';
        } else if (/stem[\s-]*zero/i.test(nombreColeccion)) {
          enlaceColeccion = '/pages/stem-zero';
        } else if (/hard[\s-]*strong/i.test(nombreColeccion)) {
          enlaceColeccion = '/pages/hard-strong';
        } else if (/gabriel[\s-]*glas/i.test(nombreColeccion)) {
          enlaceColeccion = '/pages/gabriel-glas';
        } else if (/denver.*liely/i.test(nombreColeccion)) {
          enlaceColeccion = '/pages/denver-liely';
        } else if (/m[aá]ximo.*frida|^m\s*&\s*f$|^myf$/i.test(nombreColeccion)) {
          enlaceColeccion = '/pages/myf';
        } else if (/tiki|mule|julep/i.test(nombreColeccion)) {
          enlaceColeccion = '/pages/tikis-mules-y-juleps';
        } else if (/^nude(?:\s+glass)?$/i.test(nombreColeccion)) {
          enlaceColeccion = '/pages/nude';
        } else if (/coravin/i.test(nombreColeccion) &&
                   /\bpro\b|profesional/i.test(nombreColeccion)) {
          enlaceColeccion = '/pages/coravin-pro-acceso';
        } else if (/coravin.*timeless/i.test(nombreColeccion)) {
          enlaceColeccion = '/pages/coravin-timeless';
        } else if (nombreColeccion === 'coravin') {
          enlaceColeccion = '/pages/coravin';
        }

        html +=
          '<a class="cc-encabezado__sug-simple" href="' +
          escapar(enlaceColeccion) +
          '" role="option"><span>' +
          escapar(colecciones[c].title) +
          '</span></a>';
      }
      html += '</div>';
    }

    var raizUrl = window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';

    var enlaceVerTodo = raizUrl + 'search?q=' +
      encodeURIComponent(termino) +
      '&options%5Bprefix%5D=last&type=product';

    if (busqueda === 'coravin') {
      enlaceVerTodo = '/pages/coravin';
    } else if (busqueda === 'coravin pro') {
      enlaceVerTodo = '/pages/coravin-pro-acceso';
    }

    html +=
      '<a class="cc-encabezado__sug-pie" href="' +
      escapar(enlaceVerTodo) +
      '" role="option">' +
      escapar(this.textos.verTodo || '') +
      ' “' +
      escapar(termino) +
      '”</a>';

    this.cuerpoSug.innerHTML = html;
    this.resultados = Array.prototype.slice.call(
      this.panel.querySelectorAll('[role="option"]')
    );

    for (var i = 0; i < this.resultados.length; i++) {
      this.resultados[i].id = 'cc-sug-' + i;
    }

    this.marcado = -1;
    this.abrirPanel();
    this.anunciar(destinos.length + productos.length + colecciones.length);
  };

  Encabezado.prototype.anunciar = function (total) {
    if (!this.aviso) return;
    this.aviso.textContent = total === 0
      ? this.textos.vacio || ''
      : total + ' resultados';
  };

  Encabezado.prototype.abrirPanel = function () {
    if (!this.panel) return;
    this.panel.hidden = false;
    this.campo.setAttribute('aria-expanded', 'true');
  };

  Encabezado.prototype.cerrarPanel = function () {
    if (!this.panel) return;
    this.panel.hidden = true;
    this.campo.setAttribute('aria-expanded', 'false');
    this.campo.removeAttribute('aria-activedescendant');
    this.marcado = -1;
  };

    Encabezado.prototype.navegar = function (evento) {
    if (!this.panel || this.panel.hidden || this.resultados.length === 0) return;

    var tecla = evento.key;
    if (tecla !== 'ArrowDown' && tecla !== 'ArrowUp' && tecla !== 'Enter') return;

    if (tecla === 'Enter') {
      if (this.marcado > -1) {
        evento.preventDefault();
        this.resultados[this.marcado].click();
      }
      return;
    }

    evento.preventDefault();
    if (this.marcado > -1) {
      this.resultados[this.marcado].classList.remove('esta-marcado');
    }

    if (tecla === 'ArrowDown') {
      this.marcado = this.marcado + 1 >= this.resultados.length
        ? 0 : this.marcado + 1;
    } else {
      this.marcado = this.marcado - 1 < 0
        ? this.resultados.length - 1 : this.marcado - 1;
    }

    var activo = this.resultados[this.marcado];
    activo.classList.add('esta-marcado');
    this.campo.setAttribute('aria-activedescendant', activo.id);
    if (activo.scrollIntoView) {
      activo.scrollIntoView({ block: 'nearest' });
    }
  };
  Encabezado.prototype.aplicarFijado = function () {
    if (!this.seccion || this.modoFijo === 'ninguno') return;
    this.seccion.classList.add('cc-encabezado-seccion--fijo');
    if (this.modoFijo === 'al-subir') {
      this.seccion.classList.add('cc-encabezado-seccion--transicion');
    }
  };
  Encabezado.prototype.abrirDrawer = function () {
    if (!this.drawer) return;
    var self = this;
    window.clearTimeout(this.temporizadorDrawer);
    this.drawer.classList.add('esta-montado');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.botonAbrir.setAttribute('aria-expanded', 'true');
    document.body.classList.add('cc-drawer-abierto');
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        self.drawer.classList.add('esta-abierto');
        var cerrar = self.drawer.querySelector('.cc-encabezado__drawer-cerrar');
        if (cerrar) cerrar.focus();
      });
    });
  };
  Encabezado.prototype.cerrarDrawer = function (devolverFoco) {
    if (!this.drawer) return;
    var self = this;
    this.drawer.classList.remove('esta-abierto');
    this.drawer.setAttribute('aria-hidden', 'true');
    if (this.botonAbrir) this.botonAbrir.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('cc-drawer-abierto');
    window.clearTimeout(this.temporizadorDrawer);
    this.temporizadorDrawer = window.setTimeout(function () {
      self.drawer.classList.remove('esta-montado');
    }, 320);
    if (devolverFoco && this.botonAbrir) this.botonAbrir.focus();
  };
    Encabezado.prototype.enviarBusqueda = function (evento) {
    var campoDestino = this.buscador.querySelector('[data-cc-buscador-campo]');
    var destinos = this.buscarDestinos(campoDestino ? campoDestino.value : '');
    if (destinos.length) {
      evento.preventDefault();
      if (destinos.length === 1) {
        this.cerrarPanel();
        window.location.assign(destinos[0].url);
      } else if (this.campo && this.cuerpoSug) {
        this.pintar({resources:{results:{}}}, campoDestino.value);
      } else {
        // Si las sugerencias están desactivadas, conserva la búsqueda normal.
        this.buscador.submit();
      }
      return;
    }
    this.cerrarPanel();
    var select = this.buscador.querySelector('[data-cc-buscador-select]');
    if (!select || !select.value) return;
    evento.preventDefault();
    var campo = this.buscador.querySelector('[data-cc-buscador-campo]');
    var termino = campo ? campo.value : '';
    var destino =
      this.buscador.getAttribute('action') +
      '?q=' +
      encodeURIComponent(termino) +
      '&options%5Bprefix%5D=last&type=product&' +
      select.value;
    window.location.href = destino;
  };
  Encabezado.prototype.evaluarScroll = function () {
    if (!this.seccion) return;
    var actual = window.pageYOffset || document.documentElement.scrollTop;
    var limite = this.raiz.offsetHeight;
    if (actual > limite && actual > this.ultimoScroll) {
      this.seccion.classList.add('cc-encabezado-seccion--oculto');
    } else {
      this.seccion.classList.remove('cc-encabezado-seccion--oculto');
    }
    this.ultimoScroll = actual < 0 ? 0 : actual;
  };
  Encabezado.prototype.leerConteo = function () {
    if (!this.espejo || !this.conteo) return;
    var burbuja = this.espejo.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    if (!burbuja) {
      if (this.espejo.innerHTML.trim() === '') return;
      this.conteo.setAttribute('hidden', 'hidden');
      this.conteo.textContent = '0';
      return;
    }
    var valor = burbuja.textContent.trim();
    this.conteo.textContent = valor;
    if (valor === '' || valor === '0') {
      this.conteo.setAttribute('hidden', 'hidden');
    } else {
      this.conteo.removeAttribute('hidden');
    }
  };
  Encabezado.prototype.sincronizarCarrito = function () {
    if (!this.espejo || !this.conteo || !window.MutationObserver) return;
    var self = this;
    this.observador = new MutationObserver(function () {
      self.leerConteo();
    });
    this.observador.observe(this.espejo, { childList: true, subtree: true });
  };
  Encabezado.prototype.destruir = function () {
    document.removeEventListener('keydown', this.alPulsarTecla);
    if (this.alClicFuera) document.removeEventListener('click', this.alClicFuera);
    if (this.alHacerScroll) {
      window.removeEventListener('scroll', this.alHacerScroll);
    }
    if (this.consultaDesktop.removeEventListener) {
      this.consultaDesktop.removeEventListener('change', this.alCambiarVista);
    } else if (this.consultaDesktop.removeListener) {
      this.consultaDesktop.removeListener(this.alCambiarVista);
    }
    if (this.observador) this.observador.disconnect();
    if (this.peticion && this.peticion.abort) this.peticion.abort();
    window.clearTimeout(this.temporizadorDrawer);
    window.clearTimeout(this.temporizadorSug);
    document.body.classList.remove('cc-drawer-abierto');
    if (this.seccion) {
      this.seccion.classList.remove('cc-encabezado-seccion--fijo');
      this.seccion.classList.remove('cc-encabezado-seccion--transicion');
      this.seccion.classList.remove('cc-encabezado-seccion--oculto');
    }
  };
  function iniciarEncabezados(contexto) {
    var alcance = contexto && contexto.querySelectorAll ? contexto : document;
    var nodos = alcance.querySelectorAll('[data-cc-encabezado]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccEncabezado) continue;
      nodos[i].ccEncabezado = new Encabezado(nodos[i]);
    }
  }
  function arrancarTodo() {
    iniciarEncabezados(document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancarTodo);
  } else {
    arrancarTodo();
  }
  document.addEventListener('shopify:section:load', function (evento) {
    iniciarEncabezados(evento.target);
  });
  document.addEventListener('shopify:section:unload', function (evento) {
    var nodos = evento.target.querySelectorAll('[data-cc-encabezado]');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].ccEncabezado) {
        nodos[i].ccEncabezado.destruir();
        nodos[i].ccEncabezado = null;
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
